export { default } from "./PermissionText";
